import { useState } from 'react';
import { Button, Drawer, Space, Grid, Badge } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

export interface FilterConfig {
  key: string;
  label: string;
  type: 'text' | 'select' | 'date' | 'daterange' | 'number';
  placeholder?: string;
  options?: { label: string; value: string | number }[];
  render: () => React.ReactNode;
}

interface FilterBarProps {
  filters: FilterConfig[];
  onClear?: () => void;
  onApply?: () => void;
  activeCount?: number;
  collapseToButton?: boolean;
  extra?: React.ReactNode;
}

export function FilterBar({
  filters,
  onClear,
  onApply,
  activeCount = 0,
  collapseToButton = false,
  extra,
}: FilterBarProps) {
  const screens = useBreakpoint();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const filterContent = (
    <Space wrap style={{ alignItems: 'flex-end' }}>
      {filters.map((f) => (
        <div key={f.key} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <span style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>{f.label}</span>
          {f.render()}
        </div>
      ))}
      {onApply && (
        <Button
          type="primary"
          size="small"
          onClick={onApply}
          data-testid="filter-bar-apply-btn"
        >
          Áp dụng
        </Button>
      )}
      {onClear && activeCount > 0 && (
        <Button
          onClick={onClear}
          style={{ height: 32 }}
          data-testid="filter-bar-clear-btn"
        >
          Xóa bộ lọc ({activeCount})
        </Button>
      )}
    </Space>
  );

  if (screens.md && !collapseToButton) {
    return (
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', padding: '8px 0', gap: 8 }}>
        {filterContent}
        {extra && <div style={{ flexShrink: 0 }}>{extra}</div>}
      </div>
    );
  }

  return (
    <>
      <Space style={{ marginBottom: 8 }}>
        <Badge count={activeCount} size="small" offset={[-2, 2]}>
          <Button size="small" icon={<FilterOutlined />} onClick={() => setDrawerOpen(true)}>
            Lọc
          </Button>
        </Badge>
        {extra}
      </Space>
      <Drawer
        title="Bộ lọc"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        placement={screens.md ? 'right' : 'bottom'}
        width={screens.md ? 420 : undefined}
        height={screens.md ? undefined : 'auto'}
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          {filters.map((f) => (
            <div key={f.key}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>{f.label}</div>
              {f.render()}
            </div>
          ))}
          <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
            {onClear && (
              <Button
                onClick={() => {
                  onClear();
                }}
                style={{ height: 32 }}
              >
                Xóa bộ lọc
              </Button>
            )}
            {onApply && (
              <Button
                type="primary"
                onClick={() => {
                  onApply();
                  setDrawerOpen(false);
                }}
              >
                Áp dụng
              </Button>
            )}
          </Space>
        </Space>
      </Drawer>
    </>
  );
}
